import { UiButton, UiDrawer } from "../../../../components";
import { RightOutlined } from "@ant-design/icons";
import "./style.scss"
import { Spin } from "antd";
import { Document, Page, pdfjs } from "react-pdf";
import { downloadFile } from "../../../../utils/appUtils";
import { useEffect, useState } from "react";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
const LawyerDocuments = ({
    lawyerBooleans,
    lawyerFilter,
    handleDocumentClose,
    documentData,
    handleViewDocument,
    loading,
}) => {
    const [numPages, setNumPages] = useState(null);

    const handleDownload = () => {
        if (!lawyerFilter?.documentFile || !lawyerFilter?.documentFile?.url) return;
        const fileName = lawyerFilter?.documentFile?.name || "document.pdf";
        downloadFile(lawyerFilter?.documentFile?.url, fileName);
    };

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const getFileType = (fileUrl = "") => {
        const urlStr = typeof fileUrl === 'object' ? fileUrl?.url : fileUrl;
        const extension = urlStr?.split(".")?.pop()?.toLowerCase();
        if (["pdf"]?.includes(extension)) return "pdf";
        if (["jpg", "jpeg", "png", "gif", "webp"]?.includes(extension)) return "image";
        if (["doc", "docx"]?.includes(extension)) return "word";
        return "other";
    };

    useEffect(() => {
        setNumPages(null);
    }, [lawyerFilter?.documentFile?.url]);

    return <>
        <UiDrawer
            open={lawyerBooleans?.isDocumentOpen}
            onClose={handleDocumentClose}
            placement={"left"}
            key={"left"}
            width="70%"
            title="Document's"
            footer={<>
                <div className="flexible-end">
                    <UiButton onClick={handleDocumentClose}>Close</UiButton>
                    <UiButton type="primary" onClick={handleDownload}>Download</UiButton>
                </div>
            </>}
        >
            <div style={{ display: "flex", gap: "0px 10px" }}>
                <div className="document-Name-Details">
                    <h2 className="information-detail">Document's</h2>
                    <div>
                        {documentData && documentData?.length > 0 ? (
                            documentData?.map((detail, index) => {
                                return <>
                                    <div style={{ paddingTop: "10px" }}>
                                        <div className={lawyerFilter?.active === index ? "document-active" : "document-info"} onClick={() => handleViewDocument(detail, index)}>
                                            <p style={{ padding: "5px 0px", margin: "5px" }}>{detail?.name}</p>
                                            <RightOutlined />
                                        </div>
                                    </div>
                                </>
                            })
                        ) : (
                            <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                                No documents available
                            </div>
                        )}
                    </div>
                </div>
                {loading ? <div style={{ margin: "auto" }}>
                    <Spin spinning={loading} style={{ margin: "auto" }} />
                </div> :
                    <div className="document-view" key={lawyerFilter?.documentFile?.url || 'empty'}>
                        {!lawyerFilter?.documentFile || !lawyerFilter?.documentFile?.url ? (
                            <div style={{ textAlign: "center", padding: 20 }}>
                                <p style={{ color: "#999" }}>No document selected</p>
                            </div>
                        ) : (
                            <>
                                {(() => {
                                    const fileType = getFileType(lawyerFilter?.documentFile?.url);

                                    switch (fileType) {
                                        case "pdf":
                                            return (
                                                <Document
                                                    key={lawyerFilter?.documentFile?.url}
                                                    file={lawyerFilter?.documentFile?.url}
                                                    onLoadSuccess={onDocumentLoadSuccess}
                                                    onLoadError={(error) => console.error("Error loading PDF:", error)}
                                                    loading={<p>Loading PDF...</p>}
                                                >
                                                    {Array.from({ length: numPages || 0 }, (_, index) => (
                                                        <div key={`page_${index + 1}`} style={{ marginBottom: "20px" }}>
                                                            <Page
                                                                pageNumber={index + 1}
                                                                width={600}
                                                                renderTextLayer={false}
                                                                renderAnnotationLayer={false}
                                                            />
                                                        </div>
                                                    ))}
                                                </Document>
                                            );
                                        case "image":
                                            return (
                                                <div style={{ textAlign: "center" }}>
                                                    <img
                                                        src={lawyerFilter?.documentFile?.url}
                                                        alt="document preview"
                                                        style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }}
                                                    />
                                                </div>
                                            );
                                        case "word":
                                            return (
                                                <iframe
                                                    src={`https://docs.google.com/gview?url=${encodeURIComponent(lawyerFilter?.documentFile?.url)}&embedded=true`}
                                                    title="Document Viewer"
                                                    style={{ width: "100%", height: "80vh", border: "none" }}
                                                />
                                            );
                                        default:
                                            return (
                                                <p style={{ textAlign: "center", padding: 20 }}>
                                                    Unsupported file type
                                                </p>
                                            );
                                    }
                                })()}
                            </>
                        )}
                    </div>
                }
            </div>
        </UiDrawer>
    </>
};
export default LawyerDocuments



